import React from 'react';
import { Box, Paper, Skeleton, Divider } from '@mui/material';

const RiskCardSkeleton: React.FC = () => {
  return (
    <Paper
      sx={{
        p: 2,
        mb: 2,
        boxShadow: 'none',
        border: '1px solid #e0e0e0',
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        flexWrap: 'nowrap',
        overflow: 'hidden',
      }}
    >
      {/* Icon and title section */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          minWidth: '300px',
          flexShrink: 0,
        }}
      >
        <Skeleton
          variant="circular"
          width={32}
          height={32}
          sx={{ backgroundColor: 'rgba(25, 118, 210, 0.12)' }}
        />
        <Box>
          <Skeleton variant="text" width={120} height={20} sx={{ mb: 0.5 }} />
          <Skeleton variant="text" width={100} height={14} />
        </Box>
      </Box>

      <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

      {/* Status chip */}
      <Skeleton
        variant="rounded"
        width={80}
        height={20}
        sx={{ borderRadius: 10, flexShrink: 0 }}
      />

      <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

      {/* Evaluations count */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          minWidth: '120px',
          flexShrink: 0,
        }}
      >
        <Skeleton
          variant="circular"
          width={24}
          height={24}
          sx={{ backgroundColor: 'rgba(255, 152, 0, 0.05)' }}
        />
        <Skeleton variant="text" width={20} height={16} />
        <Skeleton variant="text" width={70} height={12} sx={{ ml: 0.5 }} />
      </Box>

      <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

      {/* Last reviewer */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          minWidth: '140px',
          flexShrink: 0,
        }}
      >
        <Skeleton
          variant="circular"
          width={24}
          height={24}
          sx={{ backgroundColor: 'rgba(128, 128, 128, 0.05)' }}
        />
        <Skeleton variant="text" width={60} height={16} />
        <Skeleton variant="text" width={80} height={12} sx={{ ml: 0.5 }} />
      </Box>
    </Paper>
  );
};

export default RiskCardSkeleton;
